/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";
import BorderLinearProgress from "../BorderLinearProgress/BorderLinearProgress";
import PropTypes from "prop-types";

function SurveyChartData({
  data,
  setActiveIndex,
  activeIndex,
  textSize = 1.0,
}) {
  // Font size in rem for h6 in survey answers (base: 12px / 10px = 1.2rem)
  const headingFontSize = `${String(1.2 * textSize)}rem`;
  return (
    <>
      {data.map((option, index) => {
        return (
          <div
            key={option.id}
            style={{
              filter:
                activeIndex === index ? "brightness(95%)" : "brightness(100%)",
            }}
            onMouseEnter={() => {
              setActiveIndex(index);
            }}
            onMouseLeave={() => {
              setActiveIndex(-1);
            }}
          >
            <h6
              style={{
                fontWeight: activeIndex === index ? "900" : "500",
                fontSize: headingFontSize,
              }}
              aria-hidden
            >
              {option.text} {Math.round(option.percent)}% ({option.value})
            </h6>
            <BorderLinearProgress
              aria-hidden
              value={option.percent}
              barcolor={option.color}
              variant="determinate"
            />
            <p className="sr-only" aria-live="polite">
              {I18n.t("surveys.radio_answer", {
                answer: option.text,
                count: option.value,
                percentage: Math.round(option.percent),
              })}
            </p>
          </div>
        );
      })}
    </>
  );
}

SurveyChartData.propTypes = {
  data: PropTypes.array,
  setActiveIndex: PropTypes.func.isRequired,
  activeIndex: PropTypes.number,
};

export default SurveyChartData;
